// RADIUS Issues — per-subscriber RADIUS data-quality issues (the user's
// switch_name doesn't match where their ONU physically sits). JSON sibling
// of the legacy /v1/frag/radiuslog/main HTML page. Go side: internal/
// radiuslog (renders) + internal/radiusissues (the detector that writes
// `radius:issues` to Redis). Read-only list; fixes are per-row actions on
// other endpoints (boxchains.add for "Confirm chain", cmd.radiusTombstone
// for "Mark fixed").

import type { ApiClient } from "./client.js";

export type RadiusIssueType =
  | "r_box_wrong_box"
  | "r_box_split_on_box"
  | "r_box_no_switch"
  | "r_single_has_box"
  | "r_single_no_switch";

/** One RADIUS-issue row (internal/radiuslog/domain.go Issue). */
export interface RadiusIssue {
  type: RadiusIssueType | string;
  username: string;
  account_status?: string;
  olt: string;
  olt_ip?: string;
  onu_name: string;
  router?: string;
  /** Box-chain head this user *should* be in (for the box-* types). */
  head_norm?: string;
  head_label?: string;
  /** The switch_name on file in RADIUS today (empty = not set). */
  current_switch?: string;
  current_norm?: string;
  seen_at?: string;
  // API-only computed: parsed PON port / ONU index.
  pon?: string;
  onu?: string;
}

export interface RadiusIssueCounts {
  r_box_wrong_box: number;
  r_box_split_on_box: number;
  r_box_no_switch: number;
  r_single_has_box: number;
  r_single_no_switch: number;
  total: number;
}

export interface RadiusIssuesResponse {
  ok: boolean;
  counts?: RadiusIssueCounts;
  issues?: RadiusIssue[];
  total?: number;
  visible?: number;
  error?: string;
}

export function makeRadiusIssuesApi(client: ApiClient) {
  return {
    /** Filtered issue list + per-type counts. Filters: type / router name / OLT name / free-text q. */
    list(filters: { type?: string; router?: string; olt?: string; q?: string } = {}): Promise<RadiusIssuesResponse> {
      return client.get<RadiusIssuesResponse>("/v1/api/radiuslog/list", {
        type: filters.type,
        router: filters.router,
        olt: filters.olt,
        q: filters.q,
      });
    },
  };
}

export type RadiusIssuesApi = ReturnType<typeof makeRadiusIssuesApi>;
